@if (data) {
  <div class="_wf-pp-cartdivx2" [ngStyle]="checkItems()" [ngClass]="this.openItems ? 'cart-open' : 'cart-close'">
    <div class="_wf--pp-downarrowx2" (click)="hidecheck()">
      <div class="_wf-pp-fontawesometextboxx2">@if (openItems) {
        <i class="fa fa-angle-double-down"></i>
        } @if (!openItems) {
        <i
        class="fa fa-angle-double-up"></i>
      }</div>
    </div>
    @if (!checkdataType(data)) {
      <div class="float-left w-75">
        @if (showItems && data && openItems) {
          <div class="_wf-pp-cartpatientdetailsx2">
            <ng-template #fullPatientName>{{patientName}}</ng-template>
            @for (d of patientField; track d; let i = $index) {
              <div class="_wf-pp-patientnamex2 card_patientDetail">
                @if (d.name == 'patient_name' && data.patientdetails[d.name] != undefined) {
                  <span class="_heading-4 _hoverdata" style="font-size: 17px;" [popover]="fullPatientName"
                    triggers="mouseenter:mouseleave" placement="bottom left" (mouseover)="getName(data.patientdetails[d.name])"
                  >{{data.patientdetails[d.name]}}</span>
                }
                @if (d.name == 'patient_name' && data.patientdetails[d.name] == undefined) {
                  <span class="_heading-4" [popover]="fullPatientName" triggers="mouseenter:mouseleave"
                    placement="bottom left"  (mouseover)="getName(data.patientdetails.name_.text)"
                  >{{data.patientdetails.name_.text}}</span>
                }
              </div>
            }
          </div>
        }
        @if (showItems && data.patientdetails && openItems) {
          <div class="_wf-pp-cartpatientdetailsx2">
            <ng-template #fullPatientDetailPrimary>{{_getPatientDetailUHid()}}</ng-template>
            <div class="_wf-pp-patientnamex2 _heading-3 card_patientDetail" [popover]="fullPatientDetailPrimary"
              triggers="mouseenter:mouseleave" placement="bottom left">
              {{_getPatientDetailUHid()}}
            </div>
          </div>
        }
      </div>
    }
    @if (checkdataType(data)) {
      <div class="multi-package-container">
        @for (_randor of data.patientdetails; track _randor) {
          <div class="float-left w-75">
            @if (showItems && data && openItems) {
              <div class="_wf-pp-cartpatientdetailsx2">
                @for (d of patientField; track d; let i = $index) {
                  <div class="_wf-pp-patientnamex2">
                    @if (d.name == 'patient_name' && _randor[d.name] != undefined) {
                      <span class="_heading-4 _hoverdata" style="font-size: 17px;"
                      >{{_randor[d.name]}}</span>
                    }
                    @if (d.name == 'patient_name' && _randor[d.name] == undefined) {
                      <span class="_heading-4"
                      >{{_randor.name_.text}}</span>
                    }
                  </div>
                }
              </div>
            }
            @if (showItems && _randor && openItems) {
              <div class="_wf-pp-cartpatientdetailsx2">
                <ng-template #fullPatientDetailSecondary>{{_kxgetPatientDetailUHid(_randor)}}</ng-template>
                <div class="_wf-pp-patientnamex2 _heading-3 card_patientDetail" [popover]="fullPatientDetailSecondary"
                  triggers="mouseenter:mouseleave" placement="bottom left">
                  {{_kxgetPatientDetailUHid(_randor)}}
                </div>
              </div>
            }
          </div>
        }
      </div>
    }
    @if (showItems && data && openItems) {
      <div class="float-right w-25">
        @if (chckPermission('visit_history','appointment','appointment')) {
          <button class="secondary-btn"
            (click)="getpatientdetail(data.patientdetails)"><i class="fa fa-info" aria-hidden="true"></i></button>
          }
          @if (chckPermission('cfs_previous_visit_history','appointment','appointment')) {
            <button class="secondary-btn"
              (click)="getpatientdetailVisitHistory(data.patientdetails)"><i class="fa fa-history"
            aria-hidden="true"></i></button>
          }
        </div>
      }
      @if (showItems && data && openItems) {
        <div class="pt-3">
          @for (s of data.services; track s; let i = $index) {
            <div class="_wf-pp-patientdetailsindetailx2">
              <div class="_wf-pp-pdetailscartx2">
                <div class="_wf-pp-textboxforcartconsultationx2 text-capitalize">{{name  | translate |async}}</div>
                <div class="_wf-pp-textandtrashiconx2">
                  <div class="_wf-pp-editiconx2"><i class="fa fa-trash icon-class" (click)="removeAppointment(i)"></i>
                </div>
              </div>
            </div>
            <div class="_wf-card-level">
              @for (r of orderField; track r) {
                <div class="card-details">
                  @if (r.type != 'date') {
                    <h3 class="_heading-3">{{r.heading | translate | async}}</h3>
                  }
                  @if (r.type == 'date') {
                    <h3 class="_heading-3">{{r.heading | translate | async}}</h3>
                  }
                  @if (r.type != 'date' && r.type != 'currency') {
                    <h4 class="_heading-4"
                      [ngClass]="r.grid_color_text!=undefined && r.grid_color_text?getClass(s, r):''">
                    {{s[r.name]}}</h4>
                  }
                  @if (r.type == 'date') {
                    <h4 class="_heading-4"> {{s[r.name] | dateTimeFormat}}
                    </h4>
                  }
                  @if (r.type == 'currency') {
                    <h4 class="_heading-4">{{s.facility_id | BPcurrency}} {{s[r.name]}}
                    </h4>
                  }
                </div>
              }
            </div>
          </div>
        }
      </div>
    }
    @if (data.services.length != 0 && openItems && chckPermission('payer_view','appointment','appointment')) {
      <div class="text-center"
        >
        <button class="btn secondary-btn btn-sm mx-2 mb-2"
          (click)="payerDocument(data.patientdetails,data.selectedPayer,data.selectedPayerName)">{{'field.label.payer_document'
        | translate | async}}</button>
        <button class="btn secondary-btn btn-sm mb-2"
          (click)="payerTerms(data.patientdetails,data.selectedPayer,data.selectedPayerName)">{{'field.label.terms_and_conditions'
        | translate | async}}</button>
      </div>
    }
    @if (checkDiscCondition()) {
      <div class="text-center disclaimer">{{'same_doctor_disc' | translate |async}}</div>
    }
    <div class="appointment-remarks">
      @if (resourceDef && data && showRemarks && openItems) {
        <dhs-form [config]="config" [action]="'ADD'"
          [fieldGroup]="resourceDef.form" (questionValueChanged)="questionValueChanged($event)" [decorator]="consultationDecorator">
        </dhs-form>
      }
    </div>
    @if (showItems && data && data.services.length != 0 && openItems) {
      <div class="_wf-pp-subtoaldivx2">
        <!--  heading start-->
        <div>
          <div>
            @if (emergency_charges) {
              <small class="font-weight-bold">{{'field.label.emergency_charges' | translate
              | async}}</small>
            }
          </div>
          <div>
            @if (discount) {
              <small class="font-weight-bold discount-text">{{'field.label.discount' | translate |
              async}}</small>
            }
          </div>
          <div class="_wf-pp-subtotaldivx2">{{'field.label.Subtotal' | translate | async}}</div>
        </div>
        <!--  heading end-->
        <div>
          <div>
            @if (emergency_charges) {
              <small class="font-weight-bold">{{data.facility_id | BPcurrency}}
              {{emergency_charges}}</small>
            }
          </div>
          <div>
            @if (discount) {
              <small class="font-weight-bold discount-text">{{data.facility_id | BPcurrency}}
              {{discount}}</small>
            }
          </div>
          <div class="_wf-pp-pricetextboxforsubtotalx2">{{data.facility_id | BPcurrency}} {{total}}</div>
        </div>
      </div>
    }
    @if (showItems && data && data.services.length != 0 && openItems) {
      <div class="_wf-pp-bookappointmentdivx2">
        <div class="_wf-pp-bookappoinmenttextx2" (click)="bookOrder(total)"
          [ngStyle]="data.services.length == 0 ? {'cursor': 'not-allowed'} : {'cursor': 'pointer'}">
          {{'menu.book_appointment'| translate | async}} <i class="fa fa-check ml-2" aria-hidden="true"></i></div>
        </div>
      }
    </div>
  }
